import ModalInDrawer from "../ui/ModalInDrawer";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import NoDataScreen from "../../components/ui/temp-screens/NoDataScreen";

const HistorialCambiosPagos = ({open, onClose, data}) => {

  const eventTypeColorMap = {
    "Pago actualizado": "bg-blue-100 text-blue-800",
    "Pago añadido": "bg-green-100 text-green-800",
    "Pago eliminado": "bg-red-100 text-red-800",
  }
  return (
    <ModalInDrawer
      onClose={onClose}
      activeModal={open}
      title="Historial de cambios de pagos"
      centered
      className="max-w-5xl"
    >
      <div className="flex flex-col gap-4">
        {data && data.length > 0 ? data.map((item) => (
          <div 
            key={item.id} 
            className="bg-white rounded-lg shadow p-4 border border-gray-200 text-[10px]"
          >
            <div className="flex justify-between items-start">
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-gray-700">Evento:</span>
                  <span className={`px-2 py-1 rounded-full text-[10px] ${eventTypeColorMap[item.tipoEvento]}`}>
                    {item.tipoEvento}
                  </span>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">Detalles: </span>
                  <span className="text-gray-600 whitespace-pre-line">{item.detalles}</span>
                </div>
                <div>
                  <span className="font-semibold text-gray-700">ID Pago: </span>
                  <span className="text-gray-600">{item.idPago}</span>
                </div>
              </div>
              <div className="text-right space-y-2">
                <div className="text-[10px] text-gray-500">
                  {format(new Date(item.fecha), "PPP 'a las' HH:mm", { locale: es })}
                </div>
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-gray-700">Usuario:</span>
                  <span className="text-gray-600">{item.usuario.name}</span>
                  <img src={item.usuario.foto.url} alt="Usuario" className="w-4 h-4 rounded-full" />
                </div>
                <div className="text-[10px] text-gray-500">
                  {item.usuario.puesto} - {item.usuario.area}
                </div>
                <div className="text-[10px] text-gray-500">
                 <span className="font-semibold text-gray-700">IP: </span>
                  {item.userIp ? item.userIp : "No disponible"}
                </div>
              </div>
            </div>
          </div>
        )) : (
          <div className="text-center text-gray-500 h-48">
            <NoDataScreen text="No hay historial de cambios de pagos" border/>
          </div>
        )}
      </div>
    </ModalInDrawer>
  )
}

export default HistorialCambiosPagos;